export const GET_PMS_DIT_INVENTOR_TREND_YTD = 'GET_PMS_DIT_INVENTOR_TREND_YTD';
export const GET_PMS_DIT_INVENTOR_TREND_YTD_SUCCESS = 'GET_PMS_DIT_INVENTOR_TREND_YTD_SUCCESS';
export const GET_PMS_DIT_INVENTOR_TREND_YTD_FAILURE = 'GET_PMS_DIT_INVENTOR_TREND_YTD_FAILURE';

